import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-job-company',
  templateUrl: './job-company.component.html',
  styleUrls: ['./job-company.component.scss']
})
export class JobCompanyComponent implements OnInit {
  @Input() type: number;
  @Input() jobList: Array<Object> = [];

  @Input() link: string; //更多链接地址
  @Input() title: string = '招聘职位'; //header name
  @Output() jobSelectId: any = new EventEmitter();

  constructor(
    public _router: Router,
  ) { }

  ngOnInit() {
    // console.log("ccc::",this.jobList);
  }
  gojobPage(id: any) {
    window.scrollTo(0, 0);//页面回到顶部
    this._router.navigate(['/job/detail/', id]);
  }
  //漏油跳转
  routerUrl() {
    this._router.navigate([this.link]);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/job-company/job-company.component.ts